import { Alert, AlertTitle } from "@mui/material";

import styles from "./Notifications.module.css";

export interface Notification {
  id: string;
  /** Headline shown above the message. */
  title?: string;
  message: string;
  severity: "info" | "success" | "warning" | "error";
}

interface NotificationsProps {
  notifications: Notification[];
  onDismiss: (notification: Notification) => void;
}

/**
 * Notifications are any workspace-wide messages that are not associated with a specific panel.
 */
export function Notifications({
  notifications,
  onDismiss,
}: NotificationsProps) {
  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className={styles.notifications}>
      {notifications.map((notification) => (
        <Alert
          key={notification.id}
          onClose={() => onDismiss(notification)}
          severity={notification.severity}
        >
          <NotificationTitle title={notification.title} />
          {notification.message}
        </Alert>
      ))}
    </div>
  );
}

function NotificationTitle({ title }: { title?: string }) {
  if (!title) {
    return null;
  }

  return <AlertTitle>{title}</AlertTitle>;
}
